/* eslint-disable dot-notation */
/* eslint-disable no-undef */
/* eslint-disable camelcase */
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import cx from 'classnames';

// external-global styles must be imported in your JS.
import normalizeCss from 'normalize.css';
import s from './Layout.css';
// import ImportantMessageHeader from '../ImportantMessageHeader';
import ImportTripTease from '../ImportTripTease';
import Header from '../Header';
import Footer from '../Footer';

import FlashMessage from '../FlashMessage';
import { TYPE_ONLY_OVERLAY } from '../../actions/flashMessage';
import FormModal from '../FormModal';
import ResendBookingModal from '../ResendBookingModal';
import BookingEngineModal from '../BookingEngineModal';
import ImageGalleryModal from '../ImageGalleryModal';
import NewsletterPopup, {
  openModal as openNewsletterPopup,
} from '../NewsletterPopup';
import Popup, { openModal as openPopup } from '../Popup';
import RoomSelectModal from '../Modal/RoomSelectModal/RoomSelectModal';
// import FacebookChat from '../FacebookChat';
// eslint-disable-next-line camelcase
import helpshift_phatform_id from '../../config/helpshift_phatform_id.json';

const showNewsletterPopupWhenIdleFor = 20 * 60;
const showPopupWhenIdleFor = 20 * 60;

let IdleTimer;
if (process.env.BROWSER) {
  // eslint-disable-next-line global-require
  IdleTimer = require('react-idle-timer').default;
}

class Layout extends React.Component {
  // eslint-disable-next-line react/static-property-placement
  static propTypes = {
    children: PropTypes.node.isRequired,
    dataPopup: PropTypes.shape({
      pop_up_enabled: PropTypes.string,
    }),
    noFooter: PropTypes.bool,
    noMobileFooter: PropTypes.bool,
    flashMessage: PropTypes.shape({
      message: PropTypes.string,
      type: PropTypes.string,
    }),
    resendBooking: PropTypes.shape({
      openResendBookingModal: PropTypes.bool,
      bookingNumber: PropTypes.string,
      toEmail: PropTypes.string,
    }),
    showDeleteAccountModal: PropTypes.bool,
    showSignInModal: PropTypes.bool,
    showSignUpModal: PropTypes.bool,
    showErrorModal: PropTypes.bool,
    showNewsletterModal: PropTypes.bool,
    showRoomSelectPopupModal: PropTypes.bool,
    openNewsletterPopup: PropTypes.func,
    showPopupModal: PropTypes.bool,
    openPopup: PropTypes.func,
    showBookingEngine: PropTypes.bool,
    imageGallery: PropTypes.shape({
      show: PropTypes.bool,
      images: PropTypes.arrayOf(PropTypes.string),
      currentIndex: PropTypes.number,
    }),
    showMeetingRoomModal: PropTypes.bool,
    hotel: PropTypes.shape({
      code: PropTypes.string,
    }),
  };

  // eslint-disable-next-line react/static-property-placement
  static defaultProps = {
    noFooter: false,
    noMobileFooter: false,
    flashMessage: {
      message: '',
      type: '',
    },
    resendBooking: {
      openResendBookingModal: false,
      bookingNumber: '',
      toEmail: '',
    },
    showDeleteAccountModal: false,
    showSignUpModal: false,
    showSignInModal: false,
    showErrorModal: false,
    showNewsletterModal: false,
    showRoomSelectPopupModal: false,
    openNewsletterPopup: () => {},
    showPopupModal: false,
    openPopup: () => {},
    showBookingEngine: false,
    imageGallery: {
      show: false,
      images: [],
      currentIndex: 0,
    },
    showMeetingRoomModal: false,
    hotel: {
      code: 'main_bot',
    },
    dataPopup: {
      pop_up_enabled: 'false',
    },
  };

  constructor(props) {
    super(props);

    this.state = {
      dataPopup: props.dataPopup,
      showMarketingPopup: false,
    };
  }

  componentDidMount() {
    if (process.env.BROWSER) {
      this.content.style.minHeight = `${window.innerHeight - 400}px`;
    }
    // const script = document.createElement('script');
    // script.src = 'http://localhost:3000/helpshift/helpshift.js';
    // }

    if (this.state.dataPopup.pop_up_enabled === 'true') {
      if (window.location.pathname === '/') {
        this.props.openPopup(true);
      }
    }
  }

  componentDidUpdate() {
    // eslint-disable-next-line global-require, import/no-unresolved
    // const raw = require('../src/messages/en.json');
    // console.log(this.props.hotel && this.props.hotel.code);
    // console.log(helpshift_phatform_id);
    if (this.props.hotel && this.props.hotel.code) {
      window.helpshiftConfig = {
        platformId: helpshift_phatform_id[this.props.hotel.code].platform_id,
        domain: 'redplanethotels',
        language: 'en',
      };
    } else {
      const main_bot = 'main_bot';
      window.helpshiftConfig = {
        platformId: helpshift_phatform_id[main_bot].platform_id,
        domain: 'redplanethotels',
        language: 'en',
      };
    }
    Helpshift('updateHelpshiftConfig');
    if (this.state.dataPopup.pop_up_enabled === 'true') {
      if (
        window.location.pathname !== '/' &&
        this.state.showMarketingPopup === false
      ) {
        this.setState({ showMarketingPopup: true });
      }

      if (
        this.state.showMarketingPopup === true &&
        window.location.pathname === '/'
      ) {
        this.props.openPopup(true);
        this.setState({ showMarketingPopup: false });
      }
    }
  }

  showNewsletterWithTimeout = () => {
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'newsletterPopUpOpened' });
    }
    this.props.openNewsletterPopup(true);
  };

  // showPopupWithTimeout = () => {
  //   if (window.dataLayer) {
  //     window.dataLayer.push({ event: 'PopUpOpened' });
  //   }
  //   this.props.openPopup(true);
  // };

  render() {
    const {
      flashMessage,
      resendBooking: { openResendBookingModal, bookingNumber, toEmail },
      showSignUpModal,
      showSignInModal,
      showErrorModal,
      noMobileFooter,
      showBookingEngine,
      imageGallery,
      showNewsletterModal,
      showPopupModal,
      showMeetingRoomModal,
      showDeleteAccountModal,
      showRoomSelectPopupModal,
    } = this.props;
    const { dataPopup } = this.state;
    const showOverLay =
      (flashMessage !== null &&
        (flashMessage.message !== '' ||
          flashMessage.type === TYPE_ONLY_OVERLAY)) ||
      showSignUpModal ||
      showSignInModal ||
      showErrorModal ||
      showNewsletterModal ||
      showPopupModal ||
      showMeetingRoomModal ||
      showRoomSelectPopupModal ||
      showDeleteAccountModal;
    const style = {
      height: 'auto',
      overflowY: 'auto',
      overflowX: 'hidden',
    };
    if (process.env.BROWSER && showOverLay) {
      style.height = '100vh';
      style.overflow = 'hidden';
    }
    let enableTimer = false;
    if (process.env.BROWSER) {
      enableTimer = false;
    }
    let clientView = 'web';
    const pattern = new RegExp('(Red|Planet|RPHL)');
    if (pattern.test(navigator.userAgent)) {
      clientView = 'app';
    }
    return (
      <div style={style}>
        {enableTimer && (
          <IdleTimer
            element={window}
            onIdle={this.showNewsletterWithTimeout}
            onActive={this.OnActive}
            debounce={20}
            timeout={showNewsletterPopupWhenIdleFor}
          />
        )}
        {/* {dataPopup && enableTimer && (
          <IdleTimer
            element={window}
            onIdle={this.showPopupWithTimeout}
            onActive={this.OnActive}
            debounce={20}
            timeout={showPopupWhenIdleFor}
          />
        )} */}
        <div className={cx(showOverLay && s.overlay)}>
          {/* <ImportantMessageHeader /> */}
          {clientView === 'web' && <Header />}
          <div
            ref={content => {
              this.content = content;
            }}
            className={s.content}
          >
            {this.props.children}
          </div>
          {!this.props.noFooter && clientView === 'web' && (
            <Footer noMobileFooter={noMobileFooter} />
          )}
        </div>
        {flashMessage !== null && flashMessage.message !== '' && (
          <FlashMessage
            message={flashMessage.message}
            type={flashMessage.type}
          />
        )}
        {(showSignUpModal ||
          showSignInModal ||
          showErrorModal ||
          showMeetingRoomModal ||
          showRoomSelectPopupModal ||
          showDeleteAccountModal) && (
          <FormModal
            {...{ showDeleteAccountModal }}
            showSignUpModal={showSignUpModal}
            showSignInModal={showSignInModal}
            showErrorModal={showErrorModal}
            showMeetingRoomModal={showMeetingRoomModal}
          />
        )}
        {showRoomSelectPopupModal && <RoomSelectModal />}
        {/* {showNewsletterModal && <NewsletterPopup />} */}
        {dataPopup.pop_up_enabled === 'true' && showPopupModal && (
          <Popup dataPopup={dataPopup} />
        )}
        {openResendBookingModal && (
          <ResendBookingModal bookingNumber={bookingNumber} toEmail={toEmail} />
        )}
        {showBookingEngine && <BookingEngineModal />}
        {/* eslint-disable-next-line react/prop-types */}
        {imageGallery.visible && (
          <ImageGalleryModal
            images={imageGallery.images}
            currentIndex={imageGallery.currentIndex}
          />
        )}
        <ImportTripTease />
        {/* <FacebookChat /> */}
      </div>
    );
  }
}

const mapState = state => ({
  flashMessage: state.flashMessage,
  booking: state.booking,
  // add showDeleteAccountModal state
  showDeleteAccountModal: state.user.openDeleteAccountModal,
  showSignInModal: state.user.openSignInModal,
  showSignUpModal: state.user.openSignUpModal,
  showErrorModal: state.user.openErrorModal,
  showNewsletterModal: state.user.openNewsletterModal,
  showPopupModal: state.user.openPopupModal,
  resendBooking: state.user.resendBooking,
  showBookingEngine: state.runtime.showBookingEngine,
  imageGallery: state.runtime.imageGallery,
  showMeetingRoomModal: state.common.openMeetingRoomModal,
  showRoomSelectPopupModal: state.common.openRoomSelectPopupModal,
  hotel: state.hotel,
});

const mapDispatch = {
  openNewsletterPopup,
  openPopup,
};

export default connect(
  mapState,
  mapDispatch,
)(withStyles(normalizeCss, s)(Layout));
